import { render, staticRenderFns } from "./_purgeMatch.vue?vue&type=template&id=34696afe&scoped=true&lang=pug&"
import script from "./_purgeMatch.vue?vue&type=script&lang=js&"
export * from "./_purgeMatch.vue?vue&type=script&lang=js&"
import style0 from "./_purgeMatch.vue?vue&type=style&index=0&id=34696afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34696afe",
  null
  
)

export default component.exports